import { PreRegistrationForm } from '~/components/index'

const PreRegistration = () => <PreRegistrationForm subTitle="Pré-cadastro" />

export default PreRegistration
